<template>
  <div class="c-betch g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 选择投放账号 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 设置创意 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="md-options"></Icon> 批量确认 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler :name="item.href" v-for="item in subModules" :key="item.id">
        <template v-if="item.href === 'submit_base'">
          <Row class="c-betch-head">
            <Col span="24">
              <span :style="{ marginRight: '12px' }"><b>批量计划配置</b></span>
              <span
                >共计：账号数 <span class="g-error-text">{{ lenAccount }}</span> 个，计划数
                <span class="g-error-text">{{ submitData.length }}</span> 条</span
              >
            </Col>
          </Row>
          <Tabs v-model="current" type="card" @on-click="changeTabs">
            <div class="c-submit-control g-pull-right" slot="extra">
              <el-input-number v-model="num" controls-position="right" :precision="0" :min="1" :max="50" />
              <!-- 投放方式是全自动投放时禁用，全自动投放不能添加多个计划 -->
              <Button type="primary" :disabled="!isBatch || deliveryMethod === 3" @click="batchAdd">批量添加计划</Button>
              <Button @click="batchDel">批量删除</Button>
            </div>
            <TabPane v-for="(a, id) of bat_accounts" :label="accountTitle(a.name)" :name="a.name" :key="id"> </TabPane>
          </Tabs>
          <!-- 表格组件 -->
          <batch-table
            ref="rangeTable"
            :data="tableData"
            :loading="loading"
            :campagin="isCampagin"
            :dynwords="dynwords"
            :app-type="appType"
            :is-union="isUnion"
            @blur-budget="changeBudget"
            @on-change="changeInputLen"
            @on-select="selectCheckBox"
            @on-select-all="selectAll"
            @on-batch="batchAll"
            @on-copy="copySubmit"
            @on-delete="delSubmit"
            @on-trend="appendTrend"
            @on-delete-trend="delTrend"
            @on-selection="changeSelection"
          >
          </batch-table>
        </template>
      </moduler>
    </div>

    <!-- 提交 -->
    <div class="c-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <div class="c-betch-foot">
            <span class="b-state">计划状态</span>
            <i-switch v-model="batch.operation" size="large" true-value="enable" false-value="disable">
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
            </i-switch>
          </div>
          <Button type="default" @click.stop="back">上一步</Button>
          <Button type="primary" :loading="loading" :disabled="disabled" @click.stop="submit">
            <span v-if="loading">提交中...</span>
            <span v-else>完成</span>
          </Button>
        </Col>
      </Row>
    </div>

    <!-- 批量添加弹窗 -->
    <set-batch
      ref="setBatch"
      v-model="model"
      :loading="auding"
      :type="seType"
      :card="cardType"
      :data="setData"
      :currents="profileIds"
      :media="media"
      @on-select="asynSetBatch"
      @on-clear="clearSetData"
      @on-delete="deleteSetData"
      @on-card="changeCardType"
    >
    </set-batch>

    <!-- 素材检测弹窗 -->
    <result-image v-model="ruleModel" :table-data="ruleData" :loading="ruling" @submit="postRequest" @advice="postAdvicest" />
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import mixin from './mixin'
import { getSession, getLocalforage, clearAllLocalforage, clearSession, setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty, deepCopy, trim, getByteLen, pullKeys, timeout } from '@/common/js/utils'

import BatchTable from './components/batch/batch-table'
import SetBatch from './components/batch/set-batch'
import ResultImage from '@/components/convert/result-image'
import { getPopulationList, getLandpageData, getAdvCardData, getPlayButtons, getPlayLists } from '@/api/kuaishou.model'
import { addKuaiShouBatchTask } from '@/api/kuaishou.local.model'

// 反显广告账号
const findAccount = (child, parents) => {
  const findChild = parents.filter((ret) => {
    const childIds = ret.children.map((m) => m.id)
    return childIds.includes(child.id)
  })
  return findChild.shift() || {}
}

// 动态词
const dynwords = ['日期', '时间', '定向包名', '创意组名', '账号简称']

export default {
  name: 'ksLocalBatch',
  mixins: [mixin],
  components: {
    BatchTable,
    SetBatch,
    ResultImage
  },
  computed: {
    isCampagin() {
      return this.batch.batch_task_type === 1
    },
    isBatch() {
      return this.tableData.length && this.tableData.length < this.max
    },
    isUnion() {
      return this.union === 1 || this.sceneId
    },
    lenAccount() {
      const account = new Set(this.submitData.map((ret) => ret.account.id))
      return account.size
    },
    appType() {
      return this.platform === 1
    },
    tableData() {
      return this.submitData
        .filter((ret) => ret.account.name === this.current)
        .map((ret) => {
          return {
            index: ret.id,
            plan: ret.plan.plan_name,
            dynerr: ret.plan.dyn_err,
            dynpos: ret.plan.dyn_pos,
            account: ret.account.name,
            _account: ret.account._account,
            campaign: ret.campaign.name,
            _campaign: ret.campaign._campaign,
            target: ret.target.targetingName,
            _target: ret.target._target,
            retarget: ret.retarget.name,
            _retarget: ret.retarget._retarget,
            budget: ret.budget.value,
            budgetMode: ret.budget.mode,
            _budget: ret.budget._budget,
            creative: ret.creative.ideaName,
            _creative: ret.creative._creative,
            native: ret.native.name,
            _native: ret.native._native,
            pagespec: ret.pagespec && ret.pagespec.name,
            _pagespec: ret.pagespec && ret.pagespec._pagespec,
            profile: ret.profile && ret.profile.name,
            _profile: ret.profile && ret.profile._profile,
            play: ret.play && ret.play.name,
            _play: ret.play && ret.play._play
          }
        })
    },
    accountTitle() {
      return (title) => {
        const len = this.submitData.filter((ret) => ret.account.name === title).length
        return `${title}${len ? '(' + len + ')' : ''}`
      }
    }
  },
  data() {
    return {
      loading: null,
      auding: null,
      disabled: null,
      union: null,
      deliveryMethod: 1,

      ruling: null, // 加载动画
      ruleModel: null, // 素材检测弹窗
      ruleData: [], // 检测结果

      platform: null,
      current: null,
      bat_accounts: [],

      model: null,
      cardType: '101',
      seType: '',
      setData: [], // 待添数据
      profileIds: [],

      num: 1,
      max: 500,
      dynwords: dynwords,
      submitData: [], // 公式结果
      selection: [], // 批量选择
      batch: {
        batch_task_type: 1,
        operation: 'disable'
      }
    }
  },
  methods: {
    async initSubmitData() {
      const batch_type = getSession('batch_task_type') || 1 // 批量广告组  2 批量账号
      const account_ids = getSession('ad_account_ids') || []
      const campaign_ids = getSession('campaign_ids') || []
      const targetings = getSession('targetings') || []
      // const creativeData = getSession('creative_params') || []
      const out_plan_info = getSession('outer_plan_params') || {}
      const plan_info = getSession('inner_plan_params') || {}
      this.deliveryMethod = Number(getSession('deliveryMethod'))

      let creativeData = []

      try {
        creativeData = await getLocalforage('creative_params')
      } catch (e) {
        console.log('get local plan info error output: ', e)
      }

      try {
        const { union } = out_plan_info
        const { ch_platform_id } = plan_info
        this.union = union
        this.platform = ch_platform_id
        this.batch.batch_task_type = parseInt(batch_type)
        if (isArray(account_ids) && account_ids.length) {
          this.bat_accounts = account_ids
          this.current = account_ids[0].name
        }
        this.sources = {
          account: account_ids,
          campaign: campaign_ids,
          target: targetings,
          creative: creativeData
        }
        // 平铺广告计划
        if (parseInt(batch_type) === 1) {
          this.forSubmitGroup({ account_ids, campaign_ids, targetings, creativeData, plan_info, out_plan_info })
        } else if (parseInt(batch_type) === 2) {
          this.forSubmitGroup({ account_ids, targetings, creativeData, plan_info, out_plan_info }, true)
        }
      } catch (err) {
        console.error(err)
      }
    },
    forSubmitGroup(params, bool = false) {
      const _this = this
      let num = 0
      let group
      const {
        account_ids: account,
        campaign_ids: campaign,
        targetings: target,
        creativeData: creative,
        plan_info: plan,
        out_plan_info: out
      } = params

      if (!isArray(account) || !isArray(target) || !isArray(creative)) throw new Error('list must be the array')

      if (bool) group = account
      // 批量账号
      else {
        // 批量广告组过滤账号
        group = campaign.filter((ret) => {
          const met = findAccount(ret, account)
          return met && met.id
        })
      }

      for (let i = 0; i < group.length; i++) {
        if (num === _this.max) break
        for (let n = 0; n < target.length; n++) {
          if (num === _this.max) break
          for (let m = 0; m < creative.length; m++) {
            if (num === _this.max) break
            let submit = {
              id: num,
              account,
              campaign: bool ? {} : campaign,
              creative: deepCopy(creative[m]),
              plan: deepCopy(plan),
              out,
              budget: { value: out.day_budget, mode: out.budget }
            }
            if (bool) submit = Object.assign(submit, { account: deepCopy(group[i]) })
            else {
              submit = Object.assign(submit, {
                account: deepCopy(findAccount(group[i], account)),
                campaign: deepCopy(group[i])
              })
            }
            const { plan_name, app_ids, ch_platform_id } = deepCopy(plan)
            const copyPlan = { plan_name: `${plan_name}_${++num}` }
            if (ch_platform_id === 2) {
              const iosAPPID = app_ids.filter((_) => _.account_id === submit.account.id).pop()
              iosAPPID && Object.assign(copyPlan, { app_id: iosAPPID.app_id, package_id: iosAPPID.package_id })

              // 只取对应账号的appId
              submit.plan.app_ids = [iosAPPID]
            }
            submit = Object.assign(submit, {
              plan: Object.assign({}, submit.plan, copyPlan),
              target: deepCopy(target[n])
            })

            // 生成人群包
            const { audiences } = deepCopy(target[n]).targetingParam
            if (isArray(audiences)) {
              const idx = audiences.findIndex((_) => _.account_id === submit.account.id)
              if (audiences[idx]) {
                const { population, exclude_population, paid_audience } = audiences[idx]
                const retarget_type = population.length || exclude_population.length || paid_audience.length
                submit = Object.assign(submit, {
                  retarget: {
                    name: retarget_type ? '已配置' : '未配置人群',
                    audiences: deepCopy(audiences[idx])
                  }
                })
              } else {
                submit = Object.assign(submit, {
                  retarget: {
                    name: '未配置人群',
                    audiences: {}
                  }
                })
              }
            } else {
              submit = Object.assign(submit, {
                retarget: {
                  name: '未配置人群',
                  audiences: {}
                }
              })
            }

            console.log('submit output: ', submit)
            // 自定义创意原生广告配置
            const isCustom = submit.creative.unit_type === 4
            // 销售线索收集无原生
            // const isLink = submit.plan.landing_type === 'LINK'
            // 广告联盟无原生
            const isUnion = submit.out.union === 1
            // 广告位置只等于快手联盟优选广告无原生
            const scene = submit.creative.scene_id.length && JSON.stringify(submit.creative.scene_id) !== '[10]'
            // 20250421 支持程序化创意使用原生广告
            if (!isUnion && scene) {
              submit = Object.assign(submit, {
                native: {
                  name: '未配置原生计划',
                  native_info: {}
                }
              })
            } else {
              // 程序化无需配置
              submit = Object.assign(submit, {
                native: {
                  name: '',
                  native_info: {}
                }
              })
            }

            if (this.appType) {
              // 生成落地页
              submit = Object.assign(submit, {
                pagespec: {
                  name: '未配置落地页',
                  page_spec: {}
                }
              })
            }
            if (!this.isUnion) {
              // 高级创意
              if (isArray(submit.creative.scene_id) && submit.creative.scene_id.includes(7) && submit.creative.scene_id.length === 1) {
                submit = Object.assign(submit, {
                  profile: {
                    name: '禁止启用',
                    profile_id: []
                  }
                })
              } else {
                submit = Object.assign(submit, {
                  profile: {
                    name: '不启用',
                    profile_id: []
                  }
                })
              }
              // 生成试玩素材页
              submit = Object.assign(submit, {
                play: {
                  name: '未配置试玩',
                  playable: {}
                }
              })
            }

            _this.submitData.push(submit)

            this.validTrend(num - 1)
          }
        }
      }

      console.log('this.submitData output: ', this.submitData)
    },
    // 动态词验证
    validTrend(index) {
      if (typeof index !== 'number') return
      const { plan_name } = deepCopy(this.submitData[index].plan)
      if (isEmpty(plan_name)) return
      let dynErr = ''
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = plan_name.match(regexp)
      const count = (str, cut) => {
        if (typeof str !== 'string') return 0
        return str.split('').filter((ret) => ret === cut).length
      }
      if (count(plan_name, '{') !== count(plan_name, '}')) {
        dynErr = '动态词包格式错误'
      } else if (plan_name.replace(regexp, '').includes('{') || plan_name.replace(regexp, '').includes('{')) {
        dynErr = '动态词包标识{}不允许作为内容出现'
      } else if (isArray(values) && values.some((ret) => !this.dynwords.map((met) => `{${met}}`).includes(ret))) {
        dynErr = '动态词包不存在'
      } else if (isArray(values) && values.some((ret, i) => values.indexOf(ret) !== i)) {
        dynErr = '动态词包不能存在相同'
      }
      // 动态词位置
      let dynPos = []
      if (isArray(values)) {
        dynPos = values
          .filter((ret) => this.dynwords.map((met) => `{${met}}`).includes(ret))
          .map((m) => {
            const min = plan_name.indexOf(m)
            return [min, min + m.length]
          })
      }
      this.$set(this.submitData[index].plan, 'dyn_pos', dynPos)
      this.$set(this.submitData[index].plan, 'dyn_err', dynErr)
    },
    changeInputLen(val) {
      const [index, value] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      this.$set(this.submitData[idx].plan, 'plan_name', value)
      this.validTrend(idx)
    },
    batchAll(val) {
      const [type, index] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      if (typeof index === 'number' && idx > -1) {
        // 单项修改
        const filter = this.submitData[idx]
        const account = filter.account.id
        const profileIds = filter.profile && filter.profile.profile_id
        const playableIds = filter.play && filter.play.playable && Object.values(filter.play.playable)
        const pageId = filter.pagespec && filter.pagespec.page_spec && filter.pagespec.page_spec.page_id
        this.filters = [filter]

        if (['retarget', 'pagespec', 'profile', 'play'].includes(type)) {
          if (typeof account !== 'number') {
            this.$Message.error('请先设置计划账号')
            return
          }
          if (type === 'retarget') this.getAudienceData(account, type)
          else if (type === 'pagespec') this.getPagespecData(account, type, pageId)
          else if (type === 'profile') this.getProfilesData(account, type, profileIds)
          else if (type === 'play') this.getPlayButtonsData(account, type, playableIds)
        } else if (type === 'budget') {
          const [, , budget] = val
          if (typeof budget === 'number') this.$set(filter, 'budget', Object.assign(filter.budget, { value: budget }))
          else if (typeof budget === 'string') {
            const curBudget = { mode: budget }
            if (budget === 'BUDGET' && !filter.budget.value) Object.assign(curBudget, { value: 100 })
            this.$set(filter, 'budget', Object.assign(filter.budget, curBudget))
          }
        } else if (type === 'native') {
          const [adId] = this.bat_accounts.filter((ret) => ret.name === this.current)
          const { enable, kol_user_type, nativeId, name } = filter.native.native_info
          this.setData = { enable, kol_user_type: kol_user_type || 2, nativeId: nativeId || '', name: name || '', adId: adId.id }
          this.seType = type
          this.model = true
        } else {
          if (type === 'campaign') this.setData = this.sources[type].filter((ret) => ret.account === account)
          else this.setData = this.sources[type]

          this.model = true // 弹窗
          this.seType = type
        }
      } else {
        // 批量修改
        const filters = this.submitData.filter((ret) => ret[type][`_${type}`])
        if (!filters.length) {
          this.$Message.error('至少选择一项')
          return
        }
        // 批量广告组与人群包统一账号
        const account = filters[0].account.id
        const sameAccount = filters.every((ret) => ret.account.id === account)

        this.filters = filters

        if (['campaign', 'retarget', 'pagespec', 'profile', 'play'].includes(type) && !sameAccount) {
          this.$Message.error('请选择同一个账号的计划进行批量设置')
          return
        }
        if (type === 'retarget') this.getAudienceData(account, type)
        else if (type === 'pagespec') this.getPagespecData(account, type)
        else if (type === 'profile') this.getProfilesData(account, type, [])
        else if (type === 'play') this.getPlayButtonsData(account, type, [])
        else if (type === 'native') {
          const [adId] = this.bat_accounts.filter((ret) => ret.name === this.current)
          this.setData = { enable: false, kol_user_type: 2, nativeId: '', name: '', adId: adId.id }
          this.seType = type
          this.model = true
        } else {
          if (type === 'campaign') this.setData = this.sources[type].filter((ret) => ret.account === filters[0].account.id)
          else if (type === 'budget') {
            if (filters.length > 1) this.setData = [{ value: 0, mode: 'NONE' }]
            else if (filters.length === 1) {
              const { budget } = filters[0]
              const { value, mode } = budget
              this.setData = [{ value: value, mode }]
            }
          } else this.setData = this.sources[type]
          this.model = true // 弹窗
          this.seType = type
        }
      }
    },
    batchAdd() {
      const len = this.submitData.length
      const more = this.max - this.tableData.length
      const num = more > 50 ? this.num : more % 50
      const table = this.submitData.filter((ret) => ret.account.name === this.current).pop()
      if (!table || !len) {
        this.$Message.error('无计划不能批量复制！')
        return
      }
      const index = this.submitData.findIndex((ret) => ret.id === table.id)
      const { id } = this.submitData[len - 1]
      const { account, campaign, target, retarget, creative, native, pagespec, profile, plan, play, dynerr, out, budget } = deepCopy(
        this.submitData[index]
      )
      const { plan_name } = plan
      for (let i = 0; i < num; i++) {
        this.submitData.push({
          id: id + i + 1,
          account: deepCopy(account),
          campaign: deepCopy(campaign),
          target: deepCopy(target),
          retarget: deepCopy(retarget),
          creative: deepCopy(creative),
          pagespec: deepCopy(pagespec),
          profile: deepCopy(profile),
          budget: deepCopy(budget),
          native: deepCopy(native),
          out: deepCopy(out),
          play: deepCopy(play),
          dynerr: deepCopy(dynerr),
          plan: Object.assign({}, plan, { plan_name: `${plan_name}_${i + 1}` })
        })
      }
    },
    batchDel() {
      const len = this.selection.length
      if (!len) {
        this.$Message.error('至少选中一条计划')
        return
      }
      this.$Modal.confirm({
        title: '系统提示',
        content: `当前选中${len}条计划，确认删除？`,
        onOk: () => {
          const ids = this.selection.map((ret) => ret.index)
          this.submitData = this.submitData.filter((ret) => !ids.includes(ret.id))
        }
      })
    },
    selectAll({ type, val }) {
      if (type === 'profile') {
        this.submitData
          .filter((ret) => ret.account.name === this.current && ret.profile.name !== '禁止启用')
          .forEach((ret) => {
            this.$set(ret[type], `_${type}`, val)
          })
      } else {
        this.submitData
          .filter((ret) => ret.account.name === this.current)
          .forEach((ret) => {
            this.$set(ret[type], `_${type}`, val)
          })
      }
    },
    selectCheckBox({ type, val }) {
      const [index, bool] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      this.$set(this.submitData[idx][type], `_${type}`, bool)
    },
    copySubmit(index) {
      if (!this.isBatch) {
        this.$Message.error('计划数已达到了上限')
        return
      }
      const len = this.submitData.length
      const unshife = deepCopy(this.submitData.filter((ret) => ret.account.name === this.current)[index])
      const { id } = this.submitData[len - 1]
      unshife.id = id + 1
      unshife.plan = Object.assign(unshife.plan, { plan_name: `${unshife.plan.plan_name}复制` })
      this.submitData.push(unshife)
    },
    delSubmit(id) {
      const index = this.submitData.findIndex((ret) => ret.id === id)
      this.submitData.splice(index, 1)
    },
    asynSetBatch({ type, index }) {
      // 批量操作结果
      if (typeof type !== 'string' || (!['budget', 'bid', 'profile', 'play', 'native'].includes(type) && typeof index !== 'number')) {
        this.$Message.error('选择的类型或是值错误')
        return
      }

      if (type === 'retarget') {
        // 人群包修改
        const includes = []
        const excludes = []
        const paids = []
        const account = this.filters[0].account.id
        const retarget_type = this.setData.some((ret) => {
          return ret.select === 'include' || ret.select === 'exclude'
        })
        if (retarget_type) {
          const include = this.setData.filter((met) => met.select === 'include' && met.source !== 7).map((ret) => ret.id)
          const exclude = this.setData.filter((met) => met.select === 'exclude' && met.source !== 7).map((ret) => ret.id)
          const paid = this.setData.filter((met) => met.select === 'include' && met.source === 7).map((ret) => ret.id)
          includes.push(...include)
          excludes.push(...exclude)
          paids.push(...paid)
        }
        // 批量更改定向
        this.filters.forEach((ret) => {
          const re_name = excludes.length || includes.length || paids.length ? '已配置' : '未配置人群'
          const re_audiences = { account_id: account, exclude_population: excludes, population: includes, paid_audience: paids }
          this.$set(ret, 'retarget', { name: re_name, audiences: re_audiences })
          this.$set(ret, '_retarget', false)
        })
      } else if (type === 'account') {
        // 账号修改
        // 批量更改账号，广告组，人群包
        const old_account = this.filters[0].account.id
        this.filters.forEach((ret) => {
          const account = deepCopy(this.setData[index])
          if (account.id !== old_account) {
            this.$set(ret, 'campaign', {})
            this.$set(ret, 'retarget', {
              name: '未配置人群',
              audiences: { account_id: account.id, exclude_population: [], population: [], paid_audience: [] }
            })
            if (this.appType) this.$set(ret, 'pagespec', { name: '未配置落地页', page_spec: {} }) // 修改落地页
            if (!this.isUnion) {
              this.$set(ret, 'profile', { name: '不启用', profile_id: [] })
              this.$set(ret, 'play', { name: '未配置试玩', playable: {} })
            }
            this.$set(ret, type, account)
          }
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'budget') {
        this.filters.forEach((ret) => {
          const {
            budget,
            out: { cpa_bid, deep_conversion_bid }
          } = deepCopy(ret)
          const bid = cpa_bid || deep_conversion_bid
          if (index.mode === 'BUDGET' && index.value < bid) {
            this.$Message.error(`预算不能低计划组出价${bid}！`)
            return
          }
          Object.assign(budget, index)
          this.$set(ret, type, budget)
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'pagespec') {
        let page_spec
        if (typeof index === 'number') {
          const nVal = deepCopy(this.setData[index])
          page_spec = { name: nVal.page_name, page_spec: nVal }
        } else if (typeof index === 'object') {
          const { index: idx, override } = index
          const nVal = deepCopy(this.setData[idx])
          page_spec = { name: nVal.page_name, page_spec: Object.assign({}, nVal, { override_canvas_head_option: override }) }
        } else {
          page_spec = { name: '未配置落地页', page_spec: {} }
        }
        this.filters.forEach((ret) => {
          this.$set(ret, type, deepCopy(page_spec))
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'profile') {
        let profile
        if (isArray(index)) profile = { name: '启用', profile_id: index }
        else profile = { name: '不启用', profile_id: [] }
        this.filters.forEach((ret) => {
          this.$set(ret, type, deepCopy(profile))
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'play') {
        let play
        if (isArray(index) && index.length) {
          const [id, button] = index
          play = { name: '已配置', playable: { playable_id: id, play_button: button } }
        } else play = { name: '未配置试玩', playable: {} }
        this.filters.forEach((ret) => {
          this.$set(ret, type, deepCopy(play))
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'native') {
        this.filters
          // 只set自定义创意的计划
          // .filter((ret) => ret.creative.unit_type === 4)
          // 销售线索收集无原生
          // .filter((ret) => ret.plan.landing_type !== 'LINK')
          // 广告联盟无原生
          .filter((ret) => ret.out.union !== 1)
          // 广告位置只等于快手联盟优选广告无原生
          .filter((ret) => JSON.stringify(ret.creative.scene_id) !== '[10]')
          .forEach((ret) => {
            if (index.enable) {
              const native = {
                name: index.name,
                native_info: index
              }
              this.$set(ret, type, deepCopy(native))
            } else {
              this.$set(ret, type, { name: '未配置原生计划', native_info: {} })
            }

            this.$set(ret[type], `_${type}`, false)
          })
      } else {
        const nVal = deepCopy(this.setData[index])
        if (!nVal) {
          this.$Message.error('找不到选中值数据')
          return
        }

        // 切换计划创意，根据所选创意显示原生广告
        if (type === 'creative') {
          const isCustom = nVal.unit_type === 4
          // 广告位置只等于快手联盟优选广告无原生
          const scene = nVal.scene_id.length && JSON.stringify(nVal.scene_id) !== '[10]'

          if (isCustom && scene) {
            this.filters.forEach((ret) => {
              if (!ret.native.name) {
                this.$set(ret, 'native', {
                  name: '未配置原生计划',
                  native_info: {}
                })
              }
            })
          } else {
            this.filters.forEach((ret) => {
              this.$set(ret, 'native', {
                name: '',
                native_info: {}
              })
            })
          }
        }

        this.filters.forEach((ret) => {
          this.$set(ret, type, deepCopy(nVal))
          this.$set(ret[type], `_${type}`, false)
        })
      }
    },
    deleteSetData({ type, name }) {
      if (type === 'retarget') {
        const index = this.setData.findIndex((ret) => ret.id === name)
        if (index > -1) {
          this.$set(this.setData[index], 'select', null)
        }
      }
    },
    clearSetData({ type }) {
      if (type === 'retarget') {
        this.setData.forEach((item) => {
          this.$set(item, 'select', null)
        })
      }
    },
    getAudienceData(account, type) {
      this.auding = true
      getPopulationList({ ad_account_id: account })
        .then((data) => {
          if (typeof data !== 'symbol') this.auding = false
          if (isArray(data)) {
            // 单个显示
            let includes = []
            let excludes = []
            if (isArray(this.filters) && this.filters.length === 1) {
              const [filter] = this.filters
              const { population, exclude_population, paid_audience } = filter.retarget.audiences || {}
              if (isArray(paid_audience) && paid_audience.length) includes = paid_audience
              else if (isArray(population)) includes = population
              if (isArray(exclude_population)) excludes = exclude_population
            }
            this.setData = data.map((ret) => {
              let select
              includes.includes(ret.orientation_id) && (select = 'include')
              excludes.includes(ret.orientation_id) && (select = 'exclude')
              return {
                id: ret.orientation_id,
                name: ret.orientation_name,
                count: ret.cover_num,
                source: ret.population_type,
                third_platform_code: ret.third_platform_code,
                select
              }
            })

            this.model = true // 弹窗
            this.seType = type
          } else this.setData = []
        })
        .catch((err) => {
          this.auding = false
          console.error(err)
        })
    },
    getPagespecData(account, type, current) {
      this.auding = true
      getLandpageData({ ad_account_id: account })
        .then((data) => {
          if (typeof data !== 'symbol') this.auding = false
          if (isArray(data)) {
            this.setData = data.map((ret, index) => {
              ret.index = index
              ret.check = Number(ret.page_id) === current
              ret.page_id = Number(ret.page_id)
              return ret
            })
            this.model = true // 弹窗
            this.seType = type
          } else this.setData = []
        })
        .catch((err) => {
          this.auding = false
          console.error(err)
        })
    },
    getProfilesData(account, type, profileIds) {
      this.auding = true
      getAdvCardData({ ad_account_id: account, card_type: this.cardType })
        .then((data) => {
          if (typeof data !== 'symbol') this.auding = false
          if (isArray(data)) {
            this.setData = data
            this.model = true // 弹窗
            this.seType = type
            this.profileIds = profileIds
            this.$refs.setBatch.current = []
          } else this.setData = []
        })
        .catch((err) => {
          this.auding = false
          console.error(err)
        })
    },
    getPlayButtonsData(account, type, playableIds) {
      const param = { ad_account_id: account }
      this.auding = true
      Promise.all([getPlayButtons(param), getPlayLists(param)])
        .then((data) => {
          if (typeof data !== 'symbol') this.auding = false
          const [btns, lists] = data
          if (isArray(btns) && isArray(lists)) {
            this.setData = lists.map((ret) => {
              return { id: ret.play_id, name: ret.play_name }
            })
            this.model = true // 弹窗
            this.seType = type
            this.profileIds = playableIds
            this.$refs.setBatch.playBtns = btns
          } else this.setData = []
        })
        .catch((err) => {
          this.auding = false
          console.error(err)
        })
    },
    changeCardType(name) {
      const { id: account } = this.bat_accounts.filter((ret) => ret.name === this.current).pop()
      this.cardType = name
      this.getProfilesData(account, this.seType, [])
    },
    appendTrend(val) {
      const [index, word, selectionStart] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      const title = deepCopy(this.submitData[idx].plan.plan_name)
      const prefix = title.substring(0, selectionStart)
      const suffix = title.substring(selectionStart)
      const value = `${prefix}{${word}}${suffix}`
      if (title.indexOf(word) > -1) {
        this.$Message.error('不能使用重复的动态词')
        return
      }
      this.$set(this.submitData[idx].plan, 'plan_name', value)
      this.validTrend(idx)
    },
    delTrend(index) {
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      this.validTrend(idx)
    },
    changeSelection(val) {
      this.selection = val
    },
    changeTabs() {
      this.submitData.forEach((ret) => {
        ;['account', 'campaign', 'target', 'creative', 'native', 'retarget', 'budget', 'pagespec', 'profile', 'play'].forEach((type) => {
          if (ret[type]) {
            this.$set(ret[type], `_${type}`, false)
          }
        })
      })
    },
    changeBudget(index) {
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      const { cpa_bid, deep_conversion_bid } = this.submitData[idx].out
      const bid = cpa_bid || deep_conversion_bid
      if (this.submitData[idx].budget.value && this.submitData[idx].budget.value < bid) this.$Message.error(`预算不能低计划组出价${bid}！`)
    },
    customVaild(data) {
      const err = []
      // 导出title组
      data.forEach((ret) => {
        const title = ret.plan.plan_name
        const dyneer = ret.plan.dyn_err
        const idx = err.findIndex((ret) => ret.title === trim(title))
        if (idx > -1) err[idx].ids.push(ret.id)
        else err.push({ title: trim(title), dyneer, ids: [ret.id] })
      })
      const empties = err.filter((ret) => isEmpty(ret.title))
      const sames = err.filter((ret) => ret.title && ret.ids.length > 1)
      const mores = err.filter((ret) => {
        let len = getByteLen(ret.title)
        const regexp = /({[\u4e00-\u9fa5]{2,}})/g
        const values = ret.title.match(regexp)

        if (isArray(values)) {
          values.forEach((ret) => {
            ret === '{定向包名}' && (len += 11)
            ret === '{创意组名}' && (len += 11)
          })
        }
        return len > 90
      })
      const dyerrors = err.filter((ret) => ret.dyneer)
      return [empties, sames, mores, dyerrors]
    },
    back() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>您正在编辑内容，离开将放弃原来的批量操作，确定要退出吗？</p>',
        loading: true,
        okText: '是',
        cancelText: '否',
        onOk: () => {
          timeout(300).then(() => {
            this.$Modal.remove()
            this.$router.push({
              name: 'kuaishoulocalidea',
              query: { t: 'edit' }
            })
          })
        }
      })
    },
    submit() {
      const errRes = this.customVaild(this.submitData)
      if (errRes.some((_) => _.length)) {
        const content = errRes.map((ret, i) => {
          let profix = ''
          if (i === 1) profix = '计划名称不能相同'
          else if (i === 2) profix = '计划名称不能超过90个字符'
          else if (i === 3) profix = '计划名称中动态词规则错误'
          else profix = '计划名称不能为空'
          if (isArray(ret) && ret.length) {
            const ids = ret.map((ret) => ret.ids.map((_) => _ + 1).join(',')).join(',')
            return `<p style="word-break:break-all">${profix}，请检查以下序号的计划：${ids}</p>`
          } else return ''
        })
        this.$Modal.error({
          title: '批量计划错误，请修改：',
          content: content.join('')
        })
        // 如果错误中断
      }

      this.postRequest()
    },

    postAdvicest() {
      const advs = this.ruleData.filter((ret) => ret.advice).map((ret) => ret.planId)
      this.postRequest(advs)
    },
    postRequest(advs) {
      this.ruleModel = false
      let submitData = this.submitData
      if (advs) submitData = this.submitData.filter((ret) => advs.includes(ret.id))
      const params = Object.assign(this.batch, {
        planlist: submitData.map((ret) => {
          const out = {}
          const creative = {}
          const { value, mode } = ret.budget
          const { targetingParam } = ret.target
          const { gift, target_action_type, code, unit_type } = ret.creative

          Object.assign(targetingParam, { audiences: ret.retarget.audiences }) // 人群包更新
          Object.assign(out, { budget: mode, day_budget: mode === 'NONE' ? 0 : value }) // 预算更改
          if (gift) Object.assign(creative, { gift_data: { target_action_type, code } }) // 发送礼包
          if (unit_type === 4) Object.assign(creative, { asset_mining: undefined })

          if (ret.play) {
            const {
              playable: { playable_id, play_button }
            } = ret.play
            if (playable_id && play_button) Object.assign(out, { playable_id, play_button })
          }

          if (ret.profile && isArray(ret.profile.profile_id)) {
            // 高级创意
            const { profile_id } = ret.profile
            if (isArray(profile_id) && profile_id.length) {
              Object.assign(out, {
                adv_card_option: 1,
                card_type: this.cardType,
                adv_card_list: profile_id
              })
            }
          }

          if (ret.plan.ch_platform_id === 3) {
            ret.out.unit_material_type = 4
          }

          if (ret.plan.landing_type === 'LINK') {
            const { promoted_type } = ret.plan

            // 常规落地页
            if (promoted_type === 0) {
              // 快手建站落地页
              if (ret.out.page_type_custom === 1) {
                Object.assign(out, {
                  web_uri_type: 2,
                  site_id: ret.out.externalUrls.filter((e) => e.accountId === ret.account.id)[0].row.siteId
                })
                ret.plan.land_page_id && delete ret.plan.land_page_id
              } else if (ret.out.page_type_custom === 2) {
                // 平头哥落地页、由后端在建完计划后处理
              }
              ret.plan.externalUrls && delete ret.plan.externalUrls
            }

            // 预约投放
            if (promoted_type === 1) {
              const { site_id } = ret.out
              Object.assign(out, { web_uri_type: 2, site_id })
              ret.plan.land_page_id && delete ret.plan.land_page_id
            }

            // delete ret.out.page_type_custom
          } else {
            // APP
            ret.plan.land_page_id && delete ret.plan.land_page_id
            // 常规投放时，删除预约投放的参数
            delete ret.out.site_id
            delete ret.out.site_type
          }

          // 除了安卓，把其他平台的app定向全部删除
          if (ret.plan.ch_platform_id !== 1) {
            delete ret.target.targetingParam.app_ids
            delete ret.target.targetingParam.app_interest
            delete ret.target.targetingParam.app_interest_ids
          }

          // 搜索快投，如果开启搜索快投，可以开启搜索人群探索
          const { quick_search, target_explore } = ret.out
          if (!quick_search) {
            delete ret.out.quick_search
            delete ret.out.target_explore
          }
          // 单独开启搜索快投，删除搜索人群探索
          if (quick_search && !target_explore) {
            delete ret.out.target_explore
          }
          const { age, ...restTargetingParam } = targetingParam
          if (age && age.min && age.max) {
            // 不传值表示不限 ; 年龄区间min最小为 18 岁，需要满足 max-min>=5且 18<=min<=75,
            // 若71<=min<=75, 则max需传入100；
            // 年龄区间max最大为 100 岁；与 ages_range_v2 不能同时传。
            restTargetingParam.age_v2 = {
              min: age.min,
              max: age.max
            }

            if (age.min >= 71 && age.min <= 75) {
              restTargetingParam.age_v2.max = 100
            }
          }

          ret.out = Object.assign({}, ret.out, out)
          ret.creative = Object.assign({}, ret.creative, creative)
          ret.target = Object.assign({}, ret.target, { targetingParam: restTargetingParam })

          if (ret.native?.native_info?.enable) {
            const { kol_user_type, nativeId } = ret.native.native_info
            ret.creative = {
              ...ret.creative,
              outer_loop_native: 1,
              kol_user_type,
              nativeId
            }
          }

          let param = {
            deliveryMethod: this.deliveryMethod,
            inner_plan_params: ret.plan,
            outer_plan_params: ret.out,
            creative_params: ret.creative,
            targetings: this.paramsAdjustment(deepCopy(ret.target)) // 参数结构调整
          }

          // 一对多
          if (this.batch.batch_task_type === 1) {
            param = Object.assign(param, {
              campaign_id: ret.campaign.id,
              ad_account_id: ret.account.id
            })
          } else {
            // 一对一
            param = Object.assign(param, {
              ad_account_id: ret.account.id,
              campaign_params: Object.assign(getSession('campaign_params'), { campaign_name: ret.plan.plan_name })
            })
          }
          return param
        })
      })
      this.loading = true
      addKuaiShouBatchTask(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (data) {
          clearAllLocalforage(getSession('plan_timestamp'))
          clearSession()
          this.setOperatorStorage('operation', params.operation)
          this.disabled = true
          this.$Message.info({
            content: '提交成功！页面将 2 秒后自动关闭',
            duration: 2,
            onClose: () => {
              window.close()
            }
          })
        }
      })
    },

    paramsAdjustment(target) {
      const pullArray = [
        'region',
        'age',
        'age_v2',
        'gender',
        'android_osv',
        'ios_osv',
        'platform_os',
        'population',
        'exclude_population',
        'paid_audience',
        'audiences',
        'behavior_type',
        'intelli_extend_option'
      ]

      if (this.isUnion) {
        pullArray.push(...['device_brand_ids', 'device_price', 'network', 'behavior_interest'])
      } else if (target.targetingParam.intelli_extend_option === 1) {
        // 不是联盟，是智能定向
        pullArray.push(...['filter_converted_level'])
      } else {
        pullArray.push(
          ...['behavior_interest', 'device_brand_ids', 'device_price', 'network', 'app_interest_ids', 'app_ids', 'filter_converted_level']
        )
      }
      target.targetingParam = pullKeys(pullArray, target.targetingParam)
      return target
    },
    getOperation() {
      const account = Cookies.get('ch_op_id') || ''
      const storage = getLocal('operation')
      const operation = storage && account && storage[account] ? storage[account] : this.batch.operation
      this.$set(this.batch, 'operation', operation)
    },
    setOperatorStorage(name, value) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    }
  },
  watch: {},
  created() {
    this.getOperation()
    this.initSubmitData()
  }
}
</script>
<style lang="scss" scoped>
.c-betch {
  height: 100%;
  padding-bottom: 0;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 108px);

    .c-moduler {
      height: calc(100% - 12px);
      padding: 12px 16px;

      ::v-deep .c-moduler-range {
        height: 100%;

        > .c-moduler-title {
          margin-bottom: 8px;
        }
      }
    }
  }

  .c-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .c-betch-head {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;

    span {
      line-height: 32px;
    }

    .c-submit-control {
      button {
        margin-left: 8px !important;
      }
    }
  }

  .c-betch-foot {
    line-height: 20px;
    display: inline-flex;
    align-items: center;

    .b-state {
      padding-right: 12px;
    }
  }

  ::v-deep .ivu-btn {
    margin-left: 8px !important;
  }
}
</style>
